import React from 'react';

const ForgotPasswordForm = ({
  showNewPasswordForm,
  resetEmail, setResetEmail,
  newPassword, setNewPassword,
  confirmNewPassword, setConfirmNewPassword,
  onResetPassword,
  onSubmitNewPassword,
  onBack,
  resetCooldown,
  isSending,
  errorMessage,
  handleInputChange
}) => {
  const handleResetEmailKeyPress = (e) => {
    if (e.key === 'Enter' && resetCooldown === 0) {
      onResetPassword();
      e.preventDefault();
    }
  };

  const handleNewPasswordKeyPress = (e) => {
    if (e.key === 'Enter' && !isSending) {
      onSubmitNewPassword();
      e.preventDefault();
    }
  };

  if (showNewPasswordForm) {
    return (
      <div className="login-container">
        <input
          className="login-input"
          type="password"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => { setNewPassword(e.target.value); handleInputChange(); }}
          onKeyDown={handleNewPasswordKeyPress}
        />
        <input
          className="login-input"
          type="password"
          placeholder="Confirm New Password"
          value={confirmNewPassword}
          onChange={(e) => { setConfirmNewPassword(e.target.value); handleInputChange(); }}
          onKeyDown={handleNewPasswordKeyPress}
        />
        <button className="start-button" onClick={onSubmitNewPassword} disabled={isSending}>
          Reset Password
        </button>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>
    );
  }

  return (
    <div className="login-container">
      <input
        className="login-input"
        type="email"
        placeholder="Enter email"
        value={resetEmail}
        onChange={(e) => { setResetEmail(e.target.value); handleInputChange(); }}
        onKeyDown={handleResetEmailKeyPress}
      />
      <button
        className="start-button"
        onClick={onResetPassword}
        disabled={resetCooldown > 0}
      >
        {resetCooldown > 0 ? `Try again in ${resetCooldown}s` : "Send Reset Email"}
      </button>
      <button className="secondary-button" onClick={onBack}>
        ← Back to Login
      </button>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
};

export default ForgotPasswordForm;
